const fetchHTML = function (_options) {
    const defaults = {
        url: null,
        beforeSend: function () {},
        complete: function (_data) {},
        error: function (_status, _text) {
            console.warn(_status, _text);
        },
        debug: false,
    };
    const options = Object.assign({}, defaults, _options);

    if (options.beforeSend) options.beforeSend();

    fetch(options.url).then((response) => {
        if (!response.ok) {
            if (options.error) options.error(response.status, response.statusText);
            return;
        }

        return response.text().then((html) => {
            if (options.debug) console.log(html);
            if (options.complete) options.complete(html);
        });
    });
};

export default fetchHTML;
